import { render, staticRenderFns } from "./sms_privacy.vue?vue&type=template&id=c0806bae"
import script from "./sms_privacy.vue?vue&type=script&lang=js"
export * from "./sms_privacy.vue?vue&type=script&lang=js"
import style0 from "./sms_privacy.vue?vue&type=style&index=0&id=c0806bae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports